import { useSelector } from 'react-redux';
import { ConfigurationSchema } from 'frontastic-common';

interface Media {
  file?: string | null;
  name?: string | null;
}

interface LogoData {
  title?: string | Record<string, string>;
  media?: Media;
}

interface AppContext {
  projectConfigurationSchema: unknown[];
  projectConfiguration: Record<string, unknown>;
}

interface RootState {
  app: {
    context: AppContext;
  };
}

interface ReturnType {
  media: {
    media: Media;
  };
  logoUrl: string | null;
  title: string | null;
}

export const useLogo = (): ReturnType => {
  const context = useSelector((state: RootState) => state.app.context);

  const projectSchema = new ConfigurationSchema(
    context.projectConfigurationSchema,
    context.projectConfiguration,
  );

  const logoData = projectSchema.get('logo') as LogoData | null;
  const logoTitle = logoData?.title;
  const logoUrl = logoData?.media?.file || null;
  
  const title = logoTitle && typeof logoTitle === 'object' 
    ? Object.values(logoTitle)[0] || null 
    : (logoTitle as string) || null;
    
  const mediaData = { media: logoData?.media || null };

  return { 
    media: { 
      media: { 
        ...mediaData.media, 
        name: title 
      } 
    }, 
    logoUrl, 
    title 
  };
};